import React, { ReactElement, ReactNode } from 'react'
import { Popover, Tooltip, IconButton, SvgIcon } from '@mui/material'
import Info from '@tdcerhverv/parrotfish/dist/icons/Icons/Info.svg'
import Image, { IImage } from '../../Image'
import Typography from '@mui/material/Typography'

export interface IPopoverInfo {
  title: string
  text?: string
  image?: IImage | ReactElement
}

const PopOverInfo: (props: IPopoverInfo) => ReactElement = ({ title, text, image }) => {
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null)

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const open = Boolean(anchorEl)
  const id = 'popover-info'
  return (
    <>
      <Tooltip title={title}>
        <IconButton aria-describedby={id} onClick={handleClick}>
          <SvgIcon component={Info} viewBox={'0 0 48 48'} />
        </IconButton>
      </Tooltip>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        disablePortal={true}
      >
        {text && <Typography>{text}</Typography>}
        {image && image?.hasOwnProperty('type') ? (image as ReactNode) : <Image {...(image as IImage)} />}
      </Popover>
    </>
  )
}

export default PopOverInfo
